export function trackConversionStats (data) {
    if (pararius.env == 'dev') {
        // eslint-disable-next-line
        console.log('trackConversionStats', data);
    }

    navigator.sendBeacon('/frontend/conversion-stats/track', JSON.stringify(data));
}
